import { READ_ACTION, CUSTOMER_CHAT_RESOURCE } from '@/constants/resources'

export default [
  {
    // ?conversation=<conversationId> abre direto uma conversa (ex.: botão "Abrir chat" da ficha).
    path: '/customer-chat',
    name: 'customer-chat',
    component: () => import('@/modules/customer_chat/views/CustomerChat.vue'),
    meta: {
      resource: CUSTOMER_CHAT_RESOURCE,
      action: READ_ACTION,
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
]
